import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import CartContext from "./CartContext";

export class Services extends Component {
  static contextType = CartContext;

  renderServiceCards() {
    const services = [
      {
        title: "9AM-9PM Support",
        description:
          "Our dedicated team will assist you during onboarding and help with customization and configuration needs.",
      },
      {
        title: "Dedicated Relation Manager",
        description:
          "You’ll have a single point of contact to support your online business until you’re self-sufficient. Available on demand.",
      },
      {
        title: "Managed Support",
        description:
          "24x7 on-demand service for product configuration, updates, and troubleshooting.",
      },
      {
        title: "Onboarding & Migration",
        description:
          "We provide complete support for seamless onboarding and migration to get your store online quickly.",
      },
      {
        title: "Custom Changes",
        description:
          "Need custom functionality? We implement modifications tailored to your business requirements.",
      },
      {
        title: "New Application/Product Development",
        description:
          "Beyond eCommerce, we offer new app or product development services at competitive rates. Contact us for details.",
      },
    ];

    return services.map((service, index) => (
      <Col key={index} md={6} className="mb-4">
        <div className="bg-light p-4 h-100 shadow-sm rounded">
          <h5 className="text-uppercase mb-3">{service.title}</h5>
          <p className="mb-0 text-muted">{service.description}</p>
        </div>
      </Col>
    ));
  }

  render() {
    return (
      <div className="container-fluid py-5 bg-white">
        <div className="container">
          <div className="border-start border-5 border-primary ps-4 mb-5">
            <h6 className="text-primary text-uppercase">Services</h6>
            <h2 className="text-uppercase mb-0">Our Excellent Services</h2>
          </div>
          <Row>{this.renderServiceCards()}</Row>
        </div>
      </div>
    );
  }
}
